"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 *
 * @param {String} inputValue - the input value to format
 *
 * @returns {String} - formatted date of birth
 */
var FormatDateOfBirth = function FormatDateOfBirth(inputValue) {
  var input = inputValue;
  var regMissingMonth = /(\d{2})(\/{1})(\d{1})(\/{1})(\d{0,4})/;
  var regMissingDate = /^(\d{1})(\/{1})(\d{0,2})(\/{1})(\d{0,4})/;
  if (regMissingMonth.test(input)) {
    input = input.replace(regMissingMonth, '$1/$3');
  } else if (regMissingDate.test(input)) {
    input = input.replace(regMissingDate, '$1');
  }
  var enterSlash = input.length === 3 && input.substr(2) === '/' || input.length === 6 && input.substr(5) === '/';

  // let user add slashes
  if (!enterSlash) {
    input = input.replace(/\D/g, '').slice(0, 10);
  }
  if (input.length > 2 && !enterSlash) {
    input = input.substr(0, 2) + '/' + input.substr(2, input.length - 1);
  }
  if (input.length > 5 && !enterSlash) {
    input = input.substr(0, 5) + '/' + input.substr(5, input.length - 1);
  }
  return input.substr(0, 10);
};
var _default = exports["default"] = FormatDateOfBirth;